/* The draft/live merge every list section on this flow performs. */

/* Live rows the API has not soft-deleted. `Number(...) === 0` because
   `is_deleted` comes back as both 0 and "0" depending on the endpoint. */
export const liveSectionRows = (company, spec) =>
  (company?.[spec.companyListKey] || []).filter(
    (row) => Number(row?.[spec.joinKey]?.is_deleted) === 0
  );

/* The record inside its join wrapper. */
export const sectionRecordOf = (row, spec) => row?.[spec.joinKey];

export const mergeSectionDrafts = (draftRows, company, spec) => {
  const drafts = draftRows || [];
  const draftedIds = drafts.map((d) => d?.[spec.draftLinkKey]);

  const untouched = liveSectionRows(company, spec)
    .map((row) => sectionRecordOf(row, spec))
    .filter((record) => !draftedIds.includes(record?.[spec.idKey]));

  return [...drafts, ...untouched];
};

/* A draft row is keyed by its draft id, a live row by its own. `??` and not
   `||` so a legitimate id of 0 is not skipped over. */
export const sectionRowKey = (record, spec) =>
  record?.[spec.draftIdKey] ?? record?.[spec.idKey];

/* Transcribed: every section treats "raised" and "pending" as the same
   awaiting-review state the design draws as "Requested". */
export const sectionStatus = (record) =>
  ["raised", "pending"].includes(record?.status) ? "Requested" : record?.status;
